import { useEventHandler } from 'hook/event.hook';
import { setItem, getItem } from 'helpers/localstorage';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isBadQualityEmail,
  isResurrectedUser,
} from 'partial/EmailQualityWarning/hooks/EmailQualityWarning.hook';
import {
  updateNotificationSettings,
  getNotificationsSettings,
} from 'actions/alertSettings.actions';
import { useUserInfo } from 'hook/data/userInfo.hook';

export const useEmailUpdateAlert = () => {
  const dispatch = useDispatch();
  const eventHandler = useEventHandler();
  const userInfo = useUserInfo();
  let { settings } = useSelector(state => {
    return {
      settings: state.alertSettings.alertSettings,
    };
  });

  const isClosed = getItem('emailUpdateAlertClosed') === 'true';
  const [toggleStatus, setToggleStatus] = useState(false);
  const [showSuccess, setShowSuccess] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  //eslint-disable-next-line
  const [hasTurnedOffSettings, setHasTurnedOffSettings] = useState(
    checkTurnedOffSettings(),
  );

  const showAlert =
    isResurrectedUser() &&
    isBadQualityEmail(userInfo) &&
    hasTurnedOffSettings &&
    (!isClosed || isAnimating);

  function checkTurnedOffSettings() {
    return settings
      ? !settings.creditMonitoring.email || !settings.marketing.offerAndSavings
      : false;
  }

  const closeAlert = () => {
    setItem('emailUpdateAlertClosed', true);
    setIsAnimating(true);

    //stop animation after some ms
    setTimeout(() => {
      setIsAnimating(false);
    }, 300);
  };

  const onClickToggle = () => {
    if (toggleStatus === false) {
      eventHandler(CLICK, {
        'Click Type': 'Turn On Email Resurrected',
      });

      const newSettings = Object.assign({}, settings);
      newSettings.creditMonitoring.email = 1;
      newSettings.marketing.offerAndSavings = 1;
      newSettings.shouldStoreConsentDate = true;
      dispatch(updateNotificationSettings(newSettings, true)).then(res => {
        return dispatch(getNotificationsSettings(true));
      });
      setToggleStatus(true);

      //show success alert
      setTimeout(() => {
        setShowSuccess(true);
        setTimeout(() => {
          closeAlert();
        }, 3000);
      }, 1200);
    }
  };

  const onClickClose = () => {
    closeAlert();
  };

  return {
    showAlert,
    toggleStatus,
    onClickToggle,
    onClickClose,
    showSuccess,
    isAnimating,
  };
};
